var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#EB956A",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 415 c-95 -48 -137 -178 -87 -270 17 -32 64 -73 104 -89 145 -61 300 79 258 233 -13 50 -63 109 -107 127 -43 18 -131 18 -168 -1z m105 -145 c0 -62 -2 -70 -19 -70 -17 0 -20 9 -23 66 -3 72 -3 74 24 74 16 0 18 -9 18 -70z m0 -95 c15 -18 5 -35 -20 -35 -10 0 -22 5 -25 10 -7 11 12 40 25 40 4 0 13 -7 20 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8b7a1e33ca61d5e40a25ab0ceb03e28f.svg";
export { ForwardRef as ReactComponent };